// Locate a route inside the menu tree so a page can say where it sits.
//
// The menu is the only place that records the hierarchy — routes.js is a flat
// list — so breadcrumbs are derived from it rather than from the URL.

const exactTrail = (menu, pathname) => {
    for (const item of menu) {
        // Children first: a group and its first child often share a path (the
        // "Account" group points at /app/users, as does "Users" beneath it), and
        // the deeper match is the more specific answer.
        if (item.sublistData) {
            const childTrail = exactTrail(item.sublistData, pathname);
            if (childTrail.length) return [item, ...childTrail];
        }
        if (item.path && item.path === pathname) return [item];
    }
    return [];
};

const prefixTrail = (menu, pathname) => {
    let best = [];
    const walk = (items, ancestors) => {
        items.forEach((item) => {
            if (item.path && pathname.startsWith(item.path)) {
                const trail = [...ancestors, item];
                // Longest matching path wins, so /app/users/:id resolves to
                // Users rather than to a shorter sibling route.
                if (!best.length || item.path.length > best[best.length - 1].path.length) {
                    best = trail;
                }
            }
            if (item.sublistData) walk(item.sublistData, [...ancestors, item]);
        });
    };
    walk(menu, []);
    return best;
};

/**
 * Menu items from the root down to the entry serving `pathname`, inclusive.
 * Falls back to the longest path prefix so parameterised routes
 * (/app/merchant-terminals/42) still resolve. Empty when nothing matches.
 */
export const findMenuTrail = (menu = [], pathname = '') => {
    if (!pathname) return [];
    const exact = exactTrail(menu, pathname);
    return exact.length ? exact : prefixTrail(menu, pathname);
};

/**
 * Just the ancestors — the trail without the page itself. This is what a
 * breadcrumb should show, since the page name is already displayed as the
 * heading next to it.
 */
export const findMenuAncestors = (menu, pathname) =>
    findMenuTrail(menu, pathname).slice(0, -1);
